export default __webpack_public_path__ + "static/color-picker-chart-light-039eb2c57b0b0233d03eeae149840cd42068247ea2460463e93991e62323195e.png";